export default __webpack_public_path__ + "static/media/gallery-7-1.66ef3637.webp";